import React from "react";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";


export default function DeleteUserModel({
    openDeleteUser,
    setDeleteUser,
    userData,
    setUserDetails
}) {
 
    const url = process.env.REACT_APP_API_URL;
    const handleCloseModal =()=>{
        setDeleteUser(false)
    }


  
  const handledeleteUser = async () => {
    try {
        const result = await axios.post(`${url}/api/deleteuserDetails/${userData._id}`)
          console.log(result)
        toast.success("User deleted successfully !");
        setDeleteUser(false)
        setUserDetails((prevUserDetails) => prevUserDetails.filter(user => user._id !== userData._id))
    } catch (error) {
      console.error("Error while saving priorities:", error);
      toast.error("Something went wrong !");
    }
  };



  return (
    <>
      <Modal show={openDeleteUser} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Delete User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
         <p>Are you want to delete the user ?</p>
        </Modal.Body>
        <Modal.Footer className="mt-3">
          <Button
            style={{ backgroundColor: "#212529", color: "white" }}
            onClick={handleCloseModal}
          >
            No
          </Button>
          <Button
            style={{ backgroundColor: "#043174", color: "white" }}
            onClick={handledeleteUser}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
